var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transactions',{attrs:{"transaction-class":_vm.transactionClass,"verbose-name":JSON.parse(_vm.$route.params.sales) ? 'Retour produit' : 'Renvoi produit',"verbose-name-plural":JSON.parse(_vm.$route.params.sales) ? 'Retours produits' : 'Renvois produits',"ressource":"product-returns","colors":_vm.colors,"add":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }